import { render } from "./OdometerDisplay.vue?vue&type=template&id=75944301"
import script from "./OdometerDisplay.vue?vue&type=script&lang=js"
export * from "./OdometerDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__